import React from 'react';
import {QRCodeSVG} from 'qrcode.react';
import { estadoReciboConsumo, lineasReciboReserva, datosReciboReserva, detalleConsumoRecibo, tieneReciboConsumo } from '../../../utils/reciboReserva';
export default function ReciboReserva({ entrega }) {
  const r = entrega.recibo;
  if (!tieneReciboConsumo(entrega)) return null;
  const detalle = detalleConsumoRecibo(entrega);
  return <section className="reserva-recibo" aria-label="Recibo de consumo">
    <h4>Recibo de consumo</h4>
    <dl>{datosReciboReserva(entrega).map(([label,value])=><div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
    {!!detalle.length && <div className="reserva-recibo-detalle"><h4>Detalle de consumo</h4><ul>{detalle.map((value, index) => <li key={index}>{value}</li>)}</ul></div>}
    {r.qr&&<div className="reserva-recibo-qr"><QRCodeSVG value={r.qr} size={152} marginSize={4} level="M" aria-label="QR de consumo"/></div>}
    <p className="reserva-recibo-estado">{estadoReciboConsumo(r)}</p>
    <dl>{lineasReciboReserva(entrega).map(([label,value])=><div key={label} className="reserva-recibo-total"><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
  </section>;
}
